import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthenticationProvider } from './views/dss/AuthenticationProvider';
import ResponseHandler from './AxiosWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <GoogleOAuthProvider clientId='779401680296-0mbdg2bo9j4co26s4ldpaq9791h63l1o.apps.googleusercontent.com'>
      <AuthenticationProvider>
    <ThemeProvider theme={theme}>
      <ResponseHandler>
      <App />
    </ResponseHandler>
    </ThemeProvider>
    </AuthenticationProvider>
    </GoogleOAuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
